import { SalePointIdValue } from '@/components/modules/Application/IberiaCards/_shared/types/SalePoint';
import { LastSalePointRepositoryFactory } from '@/components/modules/Application/IberiaCards/modules/SalePointAndProduct/entities/LastSalePointRepository/LastSalePointRepositoryFactory';
import { useStandsAgent } from '@/components/modules/Application/IberiaCards/modules/SalePointAndProduct/hooks/useStandsAgent';

export const useLastSalePoint = () => {
  const { standsAgent } = useStandsAgent();
  const lastSalePointRepository = LastSalePointRepositoryFactory.getRepository();

  const storedSalePointId = standsAgent ? lastSalePointRepository.get(standsAgent.email) : undefined;

  // Ignored if the agent no longer has access to it, so the field is not prefilled with a hidden option
  const lastSalePointId =
    storedSalePointId && standsAgent?.salePointIds.includes(storedSalePointId) ? storedSalePointId : undefined;

  const saveLastSalePoint = (salePointId: SalePointIdValue) => {
    if (!standsAgent) return;
    lastSalePointRepository.set(standsAgent.email, salePointId);
  };

  return {
    lastSalePointId,
    saveLastSalePoint,
  };
};
